/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropruleadd2Inputs */

const en_dropruleadd2 = /** @type {(inputs: Dropruleadd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add rule`)
};

const de_dropruleadd2 = /** @type {(inputs: Dropruleadd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regel hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add rule" |
*
* @param {Dropruleadd2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropruleadd2 = /** @type {((inputs?: Dropruleadd2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropruleadd2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropruleadd2(inputs)
	return de_dropruleadd2(inputs)
});
export { dropruleadd2 as "dropRuleAdd" }